import script from "./SpotifyStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotifyStatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./SpotifyStatusBadge.vue?vue&type=style&index=0&id=7208343e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7208343e"]])

export default __exports__